import React, { useEffect, useState } from "react";
import { getAuthHeaders, handleAuthError } from './../../utils/authUtils';

const PricingPlans = ({ user }) => {
  const [email, setEmail] = useState("");
  const [clientSecret, setClientSecret] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isDev = process.env.REACT_APP_BASE_URL === '/dev';
  
  const stripeConfig = {
    publishableKey: isDev 
      ? "pk_test_51RrVXw1sliwK2Fk6B60lF6mPsZmmJjq6beZ3lNjzQfxRxFyUMH125wJtO2gs6GEsYrKy9lydic1D6X10w3VZRrud00QQ1V0mdb" // Replace with your test key
      : "pk_live_51RrVXw1sliwK2Fk64U74CCgYsTXZ8ibrPAJIu5AorNsaUZew2EevofK6ONry8CeCrbXSJ57qD0g1YawTY02tkogx00KnH5P25u",
    pricingTableId: isDev
      ? "prctbl_1S5h581sliwK2Fk6FSFwaff8"
      : "prctbl_1SFVCA1sliwK2Fk6ss01ADmR"
  };

  useEffect(() => {
    setEmail(user.username);
    
    if (!document.querySelector('script[src="https://js.stripe.com/v3/pricing-table.js"]')) {
      const script = document.createElement("script");
      script.src = "https://js.stripe.com/v3/pricing-table.js";
      script.async = true;
      document.body.appendChild(script);
    }

    // Create customer session when component mounts
    if (user.stripeCustomerId) {
      createCustomerSession();
    }
  }, [user.stripeCustomerId]);

  const createCustomerSession = async () => {
    try {
      setLoading(true);
      setError(null);

      // Using URL parameters to match your Spring Boot @RequestParam
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/stripe/create-customer-session?customerId=${user.stripeCustomerId}`, {
        method: 'POST',
        headers: getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error(`Failed to create customer session: ${response.statusText}`);
      }

      const data = await response.json();
      setClientSecret(data.client_secret);
    } catch (err) {
      console.error('Error creating customer session:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h2
          style={{
            textAlign: "center",
            marginBottom: "3rem",
            fontSize: "2.5rem",
            fontWeight: "bold",
            color: "#333",
          }}
        >
          Choose Your Plan {isDev && "(Dev Environment)"}
        </h2>
        <p>Loading pricing options...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h2
          style={{
            textAlign: "center",
            marginBottom: "3rem",
            fontSize: "2.5rem",
            fontWeight: "bold",
            color: "#333",
          }}
        >
          Choose Your Plan {isDev && "(Dev Environment)"}
        </h2>
        <div style={{ color: "red", marginBottom: "1rem" }}>
          Error loading pricing table: {error}
        </div>
        <button 
          onClick={createCustomerSession}
          style={{
            padding: "0.5rem 1rem",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer"
          }}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div style={{ padding: "2rem" }}>
      <h2
        style={{
          textAlign: "center",
          marginBottom: "3rem",
          fontSize: "2.5rem",
          fontWeight: "bold",
          color: "#333",
        }}
      >
        Choose Your Plan {isDev && "(Dev Environment)"}
      </h2>

      {/* Stripe Pricing Table Embed */}
      <div>
        {clientSecret && stripeConfig.publishableKey && stripeConfig.pricingTableId ? (
          <stripe-pricing-table 
            pricing-table-id={stripeConfig.pricingTableId}
            customer-session-client-secret={clientSecret}
            publishable-key={stripeConfig.publishableKey}
          />
        ) : (
          <div style={{ textAlign: "center" }}>
            <p>Unable to load pricing table</p>
            {!stripeConfig.publishableKey && <p style={{ color: "red", fontSize: "0.9rem" }}>Missing Stripe publishable key</p>}
            {!stripeConfig.pricingTableId && <p style={{ color: "red", fontSize: "0.9rem" }}>Missing pricing table ID</p>}
          </div>
        )}
      </div>
    </div>
  );
};

export default PricingPlans;